<template>
  <el-dialog title="添加术语库" class="addTerm-layer" :visible.sync="shown" :before-close="handleClose">
    <div class="addTerm-layer-wrap">
      <div class="addTerm-content">
        该术语可添加至术语库也可保存并替换到译文中。
      </div>
      <div class="addTerm-buttom">
        <el-row class="button-box-inside" :gutter="40">
          <el-col :span="12">
            <el-button type="primary" @click="()=>handleSave(termInfo,0)">保存至术语表</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="()=>handleSave(termInfo,1)">保存并替换</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { trimSpace } from '@/services/common';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: "AddTerm",
  props: ['shown', 'termInfo'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',
      'getFileInfo',
      'getFileTaskInfo'
    ])
  },

  methods: {
    ...mapActions('editor', [
      'updateAddTemporaryTermList'
    ]),
    //关闭弹出
    handleClose() {
      this.$emit("handleCancel");
    },

    //保存-替换
    async handleSave(termInfo, isReplace) {
      let fileId = null;
      const { type, taskId } = this.getUrlInfo
      if (type === 'project') {
        fileId = this.getFileInfo.id
      } else if (type === 'task' || type === 'school') {
        fileId = this.getFileTaskInfo.fileId
      }
      const params = {
        fileId,
        isReplace,
        isTermHighlight: true,
        sourceSent: trimSpace(termInfo.sourceSent),
        targetSent: trimSpace(termInfo.targetSent),
        taskId,
      }
      const { success } = await this.updateAddTemporaryTermList(params)
      if (success) {
        this.$message.closeAll()
        this.$message.success('已保存至临时术语表')
        this.handleClose()
        let taskContentListParams = this.$store.getters['editor/getTaskContentListParams'];
        let param = this.$store.getters["editor/getTaskContentListParams"];
        if (type === 'project') {
          Reflect.set(taskContentListParams, 'startSort', param.startSort);
          this.$store.dispatch("editor/getFileContent", taskContentListParams);
        } else {
          Reflect.set(taskContentListParams, 'startSort', param.startSort);
          this.$store.dispatch("editor/getTaskContent", taskContentListParams);
        }
      }
      // const self = this;
      // let params = Object();
      // let fileId = 0;
      // let urlInfo = self.$store.getters['editor/getUrlInfo'];
      // if ((urlInfo.type) === 'project') {
      //   let fileInfo = self.$store.getters['editor/getFileInfo'];
      //   fileId = (fileInfo.id);
      // } else if ((urlInfo.type) === 'task') {
      //   let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
      //   fileId = (fileTaskInfo.fileId);
      // }
      // Reflect.set(params, 'fileId', fileId);
      // Reflect.set(params, 'sourceSent', trimSpace(termInfo.params.sourceSent));
      // Reflect.set(params, 'targetSent', trimSpace(termInfo.params.targetSent));
      // Reflect.set(params, 'taskId', (urlInfo.taskId) || 0);
      // Reflect.set(params, 'isReplace', isReplace);
      // Reflect.set(params, 'isTermHighlight', true);
      // Reflect.set(params, 'termTag', null);
      // self.$store.dispatch('editor/addTermsSent', params).then((resp) => {
      //   if (resp) {
      //     console.log('更新编辑器');
      //     let editorListInfo = self.$store.getters['editor/getTaskContentList'];
      //     if (!!editorListInfo && !!(editorListInfo.transSentRespVoList)) {
      //       let editorList = (editorListInfo.transSentRespVoList);
      //     }
      //     self.handleClose();
      //   }
      // })
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>